import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faLocationDot, faCalendar, faSliders } from '@fortawesome/free-solid-svg-icons';
import '../styles/ConferenceRoomList.css';

const conferenceRooms = [
  {
    id: 1,
    name: 'Phone Room',
    capacity: 1,
    image: 'https://worklifepenn1.spaces.nexudus.com/en/publicResources/GetImage?id=1415030908',
    isPaid: false
  },
  {
    id: 2,
    name: 'Grand Assembly',
    capacity: 100,
    image: 'https://worklifepenn1.spaces.nexudus.com/en/publicResources/GetImage?id=1414940262',
    isPaid: true
  },
  {
    id: 3,
    name: 'Assembly Room 01',
    capacity: 50,
    image: 'https://worklifepenn1.spaces.nexudus.com/en/publicResources/GetImage?id=1414940157',
    isPaid: true
  },
  {
    id: 4,
    name: 'Red Maple',
    capacity: 18,
    image: 'https://worklifepenn1.spaces.nexudus.com/en/publicResources/GetImage?id=1414940147',
    isPaid: true
  }
  // Add more rooms as needed
];

function ConferenceRoomList() {
  return (
    <div className="conference-room-list">
      {/* Header */}
      <header className="list-header">
        <div className="header-left">
          <h2>Reserve space</h2>
        </div>
        {/*<div className="header-right">
          <button className="my-bookings-btn">
            <FontAwesomeIcon icon={faCalendar} />
            My bookings
          </button>
        </div>*/}
      </header>

      {/* Filters */}
      {/*<div className="filters">
        <div className="location-picker">
          <FontAwesomeIcon icon={faLocationDot} />
          <span>WorkLife Meetings by Industrious</span>
        </div>
        
        <div className="filter-bar">
          <div className="date-filter">
            <FontAwesomeIcon icon={faCalendar} />
            <span>Date and time</span>
          </div>
          <button className="filter-btn">
            <FontAwesomeIcon icon={faSliders} />
          </button>
        </div>
      </div>*/}

      {/* Results count */}
      <div className="results-count">
        <span>{conferenceRooms.length} results</span>
      </div>

      {/* Rooms Grid */}
      <div className="rooms-grid">
        {conferenceRooms.map(room => (
          <Link to={`/room/${room.id}`} key={room.id} className="room-card">
            <div className="room-image">
              <img src={room.image} alt={room.name} />
            </div>
            <div className="room-info">
              <h3>{room.name}</h3>
              <div className="room-details">
                {room.isPaid && <span className="price-indicator">$</span>}
                <div className="capacity">
                  <FontAwesomeIcon icon={faUsers} />
                  <span>{room.capacity}</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default ConferenceRoomList; 